window.theme = window.theme || {};
window.slate = window.slate || {};

/* ================ SLATE ================ */
theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (_.isUndefined(constructor)) {
      return;
    }

    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    this.instances = _.filter(this.instances, function(instance) {
      var isEventInstance = instance.id === evt.detail.sectionId;

      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(
      function(index, container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  }
});

window.slate = window.slate || {};

/**
 * iFrames
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace iframes
 */

slate.rte = {
  wrapTable: function() {
    $('.rte table').wrap('<div class="rte__table-wrapper"></div>');
  },

  iframeReset: function() {
    var $iframeVideo = $(
      '.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]'
    );
    var $iframeReset = $iframeVideo.add('.rte iframe#admin_bar_iframe');

    $iframeVideo.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="video-wrapper"></div>');
    });

    $iframeReset.each(function() {
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

window.slate = window.slate || {};

/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {
  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element
      .first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element
        .first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on(
      'click',
      function(evt) {
        this.pageLinkFocus($(evt.currentTarget.hash));
      }.bind(this)
    );
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (
        options.$container[0] !== evt.target &&
        !options.$container.has(evt.target).length
      ) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 * Alternatives
 * - Accounting.js - http://openexchangerates.github.io/accounting.js/
 *
 */

theme.Currency = (function() {
  var moneyFormat = '${{amount}}'; // eslint-disable-line camelcase

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number === null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

theme.Images = (function() {
  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Swaps the src of an image for another OR returns the imageURL to the callback function
   * @param image
   * @param element
   * @param callback
   */
  function switchImage(image, element, callback) {
    var size = this.imageSize(element.src);
    var imageUrl = this.getSizedImageUrl(image.src, size);

    if (callback) {
      callback(imageUrl, image, element); // eslint-disable-line callback-return
    } else {
      element.src = imageUrl;
    }
  }

  /**
   * +++ Useful
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    src = src || '';

    var match = src.match(
      /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\\.@]/
    );

    if (match === null) {
      return null;
    } else {
      return match[1];
    }
  }

  /**
   * +++ Useful
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(
      /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
    );

    if (match !== null) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    }

    return null;
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    switchImage: switchImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist.  Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {
  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();
    
    $(this.singleOptionSelector, this.$container).on(
      'change',
      this._onSelectChange.bind(this)
    );
  }

  Variants.prototype = _.assignIn({}, Variants.prototype, {
    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = _.map(
        $(this.singleOptionSelector, this.$container),
        function(element) {
          var $element = $(element);
          var type = $element.attr('type');
          var currentOption = {};

          if (type === 'radio' || type === 'checkbox') {
            if ($element[0].checked) {
              currentOption.value = $element.val();
              currentOption.index = $element.data('index');

              return currentOption;
            } else {
              return false;
            }
          } else {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          }
        }
      );

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = _.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = _.find(variants, function(variant) {
        return selectedValues.every(function(values) {
          return _.isEqual(variant[values.index], values.value);
        });
      });

      return found;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (
        !variant.featured_image ||
        variantImage.src === currentVariantImage.src
      ) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
//       if (
//         variant.price === this.currentVariant.price &&
//         variant.compare_at_price === this.currentVariant.compare_at_price
//       ) {
//         return;
//       }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl =
        window.location.protocol +
        '//' +
        window.location.host +
        window.location.pathname +
        '?variant=' +
        variant.id;
      window.history.replaceState({ path: newurl }, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container).val(variant.id);
    }
  });

  return Variants;
})();


/*================ MODULES ================*/
theme.Hero = (function() {
  var selectors = {
    hero: '.hero',
    heroWrapper: '.hero-wrapper',
    heroContent: '.hero-content',
    heroTitle: '.hero-content__title',
    heroControlsArrow: '.hero-content__controls-item--arrow',
    heroControlsText: '.hero-content__controls-item--text',
    heroVideo: '.slider-video'
  };

  var classes = {
    heroContentActive: 'hero-content-active',
    heroTitleActive: 'hero-title-active',
    heroLinkActive: 'hero-link-active',
    isPaused: 'is-paused'
  };

  function Hero(sectionId) {
    this.namespace = '.hero';
    this.$hero = $(sectionId);
    this.$wrapper = this.$hero.closest(selectors.heroWrapper);
    this.$heroContent = this.$wrapper.find(selectors.heroContent);
    this.$heroControlsArrow = this.$wrapper.find(selectors.heroControlsArrow);

    this.$hero.on('init' + this.namespace, this._a11y.bind(this));
    this.$hero.on('init' + this.namespace, this._arrowsInit.bind(this));
    this.$hero.on('init' + this.namespace, this._playVideo.bind(this));

    this.$hero.on(
      'init reInit afterChange' + this.namespace,
      this._showActiveContent.bind(this)
    );
    this.$hero.on(
      'init reInit afterChange' + this.namespace,
      this._showContent.bind(this)
    );
    this.$hero.on(
      'beforeChange' + this.namespace,
      this._hideContent.bind(this)
    );

    this.$hero.slick({
      accessibility: true,
      arrows: false,
      draggable: false,
      autoplay: false,
    });

  }

  Hero.prototype = _.assignIn({}, Hero.prototype, {
    _playVideo: function() {
      if($(selectors.heroVideo).length) {

        // $(selectors.heroVideo).on('mouseover', function() {
        //   $(this).get(0).play()
        // })
      }
    }, 

    _showActiveContent: function(event, slick, currentSlide) {
      // currentSlide is undefined on init,
      // set it to 0 in this case (currentSlide is 0 based)
      // eslint-disable-next-line
      var currentSlide = currentSlide || 0;
      var $heroControlsText = this.$wrapper.find(selectors.heroControlsText);
      var $heroTitle = this.$wrapper.find(selectors.heroTitle);
      if (slick.slideCount > 1) {
        var $currentTitle = $heroTitle.filter(
            '[data-slide-id="' + (currentSlide + 1) + '"]'
          ),
          $currentLink = $heroControlsText.filter(
            '[data-slide-id="' + (currentSlide + 1) + '"]'
          );

        $heroTitle.removeClass(classes.heroTitleActive);
        $currentTitle.addClass(classes.heroTitleActive);
        $heroControlsText.removeClass(classes.heroLinkActive);
        $currentLink.addClass(classes.heroLinkActive);
      }
    },

    _hideContent: function() {
      this.$heroContent.removeClass(classes.heroContentActive);
    },

    _showContent: function() {
      this.$heroContent.addClass(classes.heroContentActive);
    },

    _a11y: function(event, obj) {
      var $list = obj.$list;
      var $heroWrapper = $(event.currentTarget).parents(selectors.heroWrapper);
      
     
  // Remove default Slick aria-live attr until slider is focused
      	$list.removeAttr('aria-live');
     
      this.$heroContent.removeAttr('aria-live');

      // When an element in the slider is focused
      // pause slideshow and set aria-live
      $heroWrapper
        .on(
          'focusin' + this.namespace,
          function(evt) {
            if (!$heroWrapper.has(evt.target).length) {
              return;
            }

            this.$heroContent.attr('aria-live', 'polite');
          }.bind(this)
        )
        .on(
          'focusout' + this.namespace,
          function(evt) {
            if ($heroWrapper.has(evt.relatedTarget).length) {
              return;
            }

            this.$heroContent.removeAttr('aria-live');
          }.bind(this)
        )
        .on('keyup', this._keyboardNavigation.bind(this));
    },

    _arrowsInit: function(event, obj) {
      // Slider is initialized. Setup custom arrows
      var count = obj.slideCount;
      var $slider = obj.$slider;
      var $arrows = this.$heroControlsArrow;

      if ($arrows.length && count > 1) {
        $arrows.on(
          'click' + this.namespace,
          function(evt) {
            evt.preventDefault();
            var $arrowButton = $(evt.currentTarget).find('button');
            var arrowButtonControl = $arrowButton.data('control');
            if (arrowButtonControl === 'previous') {
              $slider.slick('slickPrev');
            } else if (arrowButtonControl === 'next') {
              $slider.slick('slickNext');
            }
            this._scrollTop();
          }.bind(this)
        );
      } else {
        $arrows.remove();
      }
    },

    _scrollTop: function() {
      var currentScroll = $(document).scrollTop();
      var heroOffset = this.$hero.offset().top;

      if (currentScroll > heroOffset) {
        $('html')
          .add('body')
          .animate(
            {
              scrollTop: heroOffset
            },
            250
          );
      }
    },

    _keyboardNavigation: function(event) {
      if (event.keyCode === 37) {
        this.$hero.slick('slickPrev');
      }
      if (event.keyCode === 39) {
        this.$hero.slick('slickNext');
      }
    },

    goToSlide: function(slideIndex) {
      this.$hero.slick('slickGoTo', slideIndex);
    },
    destroy: function() {
      this.$hero.off(this.namespace);
      this.$heroContent.off(this.namespace);
      this.$wrapper.off(this.namespace);
      this.$heroControlsArrow.off(this.namespace);

      this.$hero.slick('unslick');
    }
  });

  return Hero;
})();

window.Modals = (function() {
  var Modal = function(id, name, options) {
    var defaults = {
      close: '.js-modal-close',
      open: '.js-modal-open-' + name,
      openClass: 'modal--is-active'
    };

    this.$modal = $('#' + id);
    if (!this.$modal.length) {
      return false;
    }

    this.nodes = {
      $body: $('body')
    };

    this.config = $.extend(defaults, options);

    this.modalIsOpen = false;
    this.$focusOnOpen = this.config.focusOnOpen
      ? $(this.config.focusOnOpen)
      : this.$modal;
    this.init();
  };

  Modal.prototype.init = function() {
    var $openBtn = $(this.config.open);

    // Add aria controls
    $openBtn.attr('aria-expanded', 'false');

    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$modal.find(this.config.close).on('click', $.proxy(this.close, this));
  };

  Modal.prototype.open = function(evt) {
    // Keep track if modal was opened from a click, or called by another function
    var externalCall = false;

    // don't open an opened modal
    if (this.modalIsOpen) {
      return;
    }

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the modal opens, the click event bubbles up to $nodes.page
    // which closes the modal.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.modalIsOpen && !externalCall) {
      return this.close();
    }

    this.$modal.addClass(this.config.openClass);
    this.nodes.$body.addClass(this.config.openClass);

    this.modalIsOpen = true;

    // Set focus on modal
    slate.a11y.trapFocus({
      $container: this.$modal,
      namespace: 'modal_focus',
      $elementToFocus: this.$focusOnOpen
    });

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    this.bindEvents();
  };

  Modal.prototype.close = function() {
    // don't close a closed modal
    if (!this.modalIsOpen) {
      return;
    }

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    this.$modal.removeClass(this.config.openClass);
    this.nodes.$body.removeClass(this.config.openClass);

    this.modalIsOpen = false;

    // Remove focus on modal
    slate.a11y.removeTrapFocus({
      $container: this.$modal,
      namespace: 'modal_focus'
    });

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'false').focus();
    }

    this.unbindEvents();
  };

  Modal.prototype.bindEvents = function() {
    // Pressing escape closes modal
    this.nodes.$body.on(
      'keyup.modal',
      $.proxy(function(evt) {
        if (evt.keyCode === 27) {
          this.close();
        }
      }, this)
    );
  };

  Modal.prototype.unbindEvents = function() {
    this.nodes.$body.off('.modal');
  };

  return Modal;
})();

window.Meganav = (function() {
  var Meganav = function(options) {
    this.cache = {
      $document: $(document),
      $page: $('.page-element')
    };

    var defaults = {
      $meganavs: $('.meganav'),
      $megaNav: $('.meganav__nav'),
      $meganavToggle: $('.meganav-toggle'),
      $meganavToggleThirdLevel: $('.meganav__link-toggle'),
      $meganavLinkSecondLevel: $('.meganav__link--second-level'),
      $meganavLinkThirdLevel: $('.meganav__link--third-level'),
      $meganavDropdownThirdLevel: $('.site-nav__dropdown--third-level'),
      isOpen: false,
      preventDuplicates: false,
      closeOnPageClick: false,
      closeThirdLevelOnBlur: false,
      activeClass: 'meganav--active',
      drawerClass: 'meganav--drawer',
      meganavDropdown: '.site-nav__dropdown',
      meganavLinkClass: 'meganav__link',
      drawerToggleClass: 'drawer__nav-toggle-btn',
      drawerNavItem: '.drawer__nav-item',
      secondLevelClass: 'meganav__link--second-level',
      thirdLevelClass: 'meganav__link-toggle',
      thirdLevelContainerClass: 'site-nav__dropdown--third-level',
      noAnimationClass: 'meganav--no-animation'
    };

    this.config = $.extend(defaults, options);
    this.init();
  };

  Meganav.prototype.init = function() {
    var $openBtn = this.config.$meganavToggle;

    $openBtn.on('click', $.proxy(this.requestMeganav, this));

    if (this.config.closeThirdLevelOnBlur) {
      this.config.$meganavLinkThirdLevel.on(
        'blur',
        $.proxy(this.closeThirdLevelMenu, this)
      );
    }
  };

  Meganav.prototype.requestMeganav = function(evt) {
    var $targetedMeganav;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    }

    // Without this, the meganav opens, the click event bubbles up to
    // theme.cache.$page which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
    }

    var $el = $(evt.currentTarget);
    var anotherNavIsOpen = this.config.isOpen;
    var isThirdLevelBtn = $el.hasClass(this.config.thirdLevelClass);

    // The $targetedMeganav is different for the drawer and non-drawer navs
    if ($el.hasClass(this.config.drawerToggleClass)) {
      $targetedMeganav = $el
        .closest(this.config.drawerNavItem)
        .children('.' + this.config.drawerClass);
    } else {
      $targetedMeganav = $el.siblings(this.config.meganavDropdown);
    }

    // Navigate to link href or close menu if already active
    if ($el.hasClass(this.config.activeClass) && $el.is('a')) {
      window.location = $el.attr('href');
      return;
    }

    // If true, don't let multiple meganavs be open simultaneously
    if (!isThirdLevelBtn && this.config.preventDuplicates) {
      this.close();
    }

    if ($targetedMeganav.hasClass(this.config.drawerClass)) {
      var isExpanded = $el.attr('aria-expanded') === 'true';

      $el
        .toggleClass(this.config.activeClass)
        .attr('aria-expanded', !isExpanded);

      $targetedMeganav.stop().slideToggle(200);
    } else {
      $el.addClass(this.config.activeClass).attr('aria-expanded', 'true');

      // Show targeted nav, letting it know whether another meganav is already open
      this.open($el, $targetedMeganav, anotherNavIsOpen);
    }

    // Setup event handlers when meganav is open
    this.bindEvents();
    this.config.isOpen = true;
  };

  Meganav.prototype.updateThirdLevelContainerWidth = function($el, $dropdown) {
    var $thirdLevel = $dropdown.find(this.config.$meganavDropdownThirdLevel);

    if (!$thirdLevel.length) {
      return;
    }

    $.each(
      $thirdLevel,
      function(key, container) {
        var $container = $(container);
        var $lastChild = $container.find('li:last-child');

        this.updateContainerWidth($container, $lastChild);
      }.bind(this)
    );
  };

  Meganav.prototype.updateContainerWidth = function(container, element) {
    var containerRect = container[0].getBoundingClientRect();
    var elementRect = element[0].getBoundingClientRect();

    if (elementRect.left < containerRect.right) {
      return;
    }

    var columnWidth = containerRect.width;
    var containerFixedWidth =
      elementRect.left + columnWidth - containerRect.left;
    var numberOfColumns = containerFixedWidth / columnWidth;
    var containerPercentageWidth = numberOfColumns * 20;

    container
      .width(containerPercentageWidth + '%')
      .find('li')
      .css('width', 100 / numberOfColumns + '%');
  };

  Meganav.prototype.open = function($el, $target, noAnimation) {
    var isThirdLevelBtn = $el.hasClass(this.config.thirdLevelClass);

    $target.addClass(this.config.activeClass);

    if (isThirdLevelBtn) {
      this.toggleSubNav($el, $target);
    }

    // Add class to override animation - CSS determined
    if (noAnimation) {
      $target.addClass(this.config.noAnimationClass);
    }
  };

  Meganav.prototype.toggleSubNav = function($el) {
    this.removeMenuActiveState();

    $el
      .addClass(this.config.activeClass)
      .attr('aria-expanded', 'true')
      .siblings(this.config.$meganavDropdownThirdLevel)
      .addClass(this.config.activeClass);

    $el.parent().addClass(this.config.activeClass);
  };

  Meganav.prototype.close = function(evt, $target) {
    if (this.config.preventDuplicates) {
      // Close all meganavs
      this.config.$meganavs.removeClass(
        [this.config.activeClass, this.config.noAnimationClass].join(' ')
      );
      this.config.$meganavToggle
        .removeClass(this.config.activeClass)
        .attr('aria-expanded', 'false');

    } else {
      // Close targeted nav
      var $targetedMeganav = $('#' + $target.attr('aria-controls'));
      $targetedMeganav.removeClass(
        [this.config.activeClass, this.config.noAnimationClass].join(' ')
      );
      $target
        .removeClass(this.config.activeClass)
        .attr('aria-expanded', 'false');
    }

    // Remove event listeners
    this.unbindEvents();
    this.config.isOpen = false;
  };

  Meganav.prototype.closeThirdLevelMenu = function(evt) {
    var $el = $(evt.currentTarget);
    var $parent = $el.parent();

    if (!$parent.is(':last-child')) {
      return;
    }

    this.config.$meganavLinkSecondLevel.one(
      'focus.meganav',
      $.proxy(function() {
        this.removeMenuActiveState();
      }, this)
    );
  };

  Meganav.prototype.removeMenuActiveState = function() {
    var activeClasses = [this.config.activeClass, this.config.noAnimationClass];

    this.config.$meganavToggleThirdLevel
      .removeClass(activeClasses.join(' '))
      .attr('aria-expanded', 'false');

    this.config.$meganavDropdownThirdLevel.removeClass(activeClasses.join(' '));
  };

  Meganav.prototype.bindEvents = function() {
    if (!this.config.closeOnPageClick) {
      return;
    }

    // Clicking away from the meganav will close it
    this.cache.$page.on('click.meganav', $.proxy(this.close, this));

    // Exception to above: clicking anywhere on the meganav will NOT close it
    this.config.$meganavs.on(
      'click.meganav',
      function(evt) {
        // 3rd level container
        var is3rdLevelMenuTarget =
          $(evt.currentTarget).hasClass(this.config.activeClass) &&
          $(evt.currentTarget).hasClass(this.config.thirdLevelContainerClass);

        // 2nd level mega link
        var isMegaNavlink =
          $(evt.target).hasClass(this.config.meganavLinkClass) &&
          $(evt.target).hasClass(this.config.secondLevelClass);

        // If we click anything outside from the 3rd level megaNav, close the third level menu (except for 2nd level links)
        if (!is3rdLevelMenuTarget && !isMegaNavlink) {
          this.removeMenuActiveState();
        }

        evt.stopImmediatePropagation();
      }.bind(this)
    );

    // Pressing escape closes meganav and focuses the target parent link
    this.cache.$document.on(
      'keyup.meganav',
      $.proxy(function(evt) {
        if (evt.keyCode !== 27) return;

        this.config.$meganavToggle
          .filter('.' + this.config.activeClass)
          .focus();
        this.close();
      }, this)
    );
  };

  Meganav.prototype.unbindEvents = function() {
    if (!this.config.closeOnPageClick) {
      return;
    }

    this.cache.$page.off('.meganav');
    this.config.$meganavs.off('.meganav');
    this.cache.$document.off('.meganav');
    this.config.$meganavLinkSecondLevel.off('.meganav');
    this.config.$meganavLinkThirdLevel.off('.meganav');
  };

  return Meganav;
})();

window.AjaxCart = (function() {
  var selectors = {
    upsellSlider: '.product-upsell-modal .upsell-slider .slider'
  }
  var cart = function($form) {
    this.cache = {
      $cartIconIndicator: $('.site-header__cart-indicator')
    };
    this.$form = $form;
    this.$submit = $form.find('button[type="submit"]');
    this.showModal = $form.find('input[name="confirmation-modal"]').val()
    this.hasUpsells = $form.find('input[name="product-upsells"]').val()
    this.isUpsell = $form.find('input[name="product-upsell"]').val()
    this.productID = $form.find('input[name="product-id"]').val()
    this.freeProduct = $form.find('input[name="free-products"]').val()
    this.eventListeners();
  };

  cart.prototype.eventListeners = function() {
    if (this.$form.length) {
      var _this = this;
      this.$form.on('submit', function(evt) {
        evt.preventDefault();
        _this.confirmationModal(_this)
      });
    }
  };

  cart.prototype.confirmationModal = function(_this) {
    var _this = this;

    if (this.showModal) {
      $('#ConfirmationModal').addClass('modal--is-active');

      $('#ConfirmationModal').find('#TrampolineSizeGuide').html('<img src="'+this.showModal+'" alt="Trampoline size guide">')

      $('#ConfirmationModal').find('.js-modal-select').unbind('click').bind('click', function() {
        $(this).addClass('loading');
        _this.addItemFromForm(_this.productID);
      });

      $('#ConfirmationModal').find('.js-modal-close-size, .js-modal-close').on('click', function() {
        $('#ConfirmationModal').removeClass('modal--is-active');
        
        if ($("#trampoline-sizes").length) {
          $('html, body').animate({
            scrollTop: $("#trampoline-sizes").offset().top - 200
          }, 1000);
        } 
      });
      
    } else {
      _this.addItemFromForm();
    }
  };

  cart.prototype.addItemFromForm = function(_this) {
    this.cache.prevCartCount = this.cache.$cartIconIndicator.text();

    var params = {
      type: 'POST',
      url: '/cart/add.js',
      data: this.$form.serialize(),
      dataType: 'json',
      success: $.proxy(function(lineItem) {
        this.success(lineItem);
      }, this),
      error: $.proxy(function(XMLHttpRequest, textStatus) {
        this.error(XMLHttpRequest, textStatus);
      }, this)
    };

    $.ajax(params);
    
  };

  cart.prototype.success = function(lineItem) {
    var _this = this;

    $.ajax({
      type: 'GET',
      url: '/cart.json',
      dataType: 'json',
      success: function(data) { 
        _this.cache.$cartIconIndicator.text(data.item_count);

        if(lineItem.product_type == 'Trampoline') {
          _this.addFreeItems(data.items)
        }
      }
    });

    if(lineItem.product_type != 'Trampoline') {
      _this.success2();
    }
  };

  cart.prototype.success2 = function() {
    var _this = this;
console.log('success 2');
    $('#ConfirmationModal').removeClass('modal--is-active');
    $('#ConfirmationModal').find('.js-modal-select').removeClass('loading');

console.log('success 23');
    if (_this.hasUpsells && _this.hasUpsells != '&nbsp;' ) {
      _this.UpsellModal = new window.Modals(
        'UpsellModal-'+_this.productID
      );
console.log('UpsellModal-'+_this.productID);
      
      _this.UpsellModal.open();

console.log('success 24');
      if ($(selectors.upsellSlider).length) {
        $(selectors.upsellSlider).each(function() {
          $(this).slick({
            slidesToShow: 3,
            dots: true,
            prevArrow: $(this).parent().find('.prev'),
            nextArrow: $(this).parent().find('.next'),
            centerMode: true,
            responsive: [
              {
                breakpoint: 800,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1
                }
            }]
          })
        })
      }
    }

console.log('success 25');
    if (_this.isUpsell) {
      _this.$submit.attr('disabled', 'disabled');
      _this.$submit.html('Added');
    } else {
      theme.Notify.open('success', false, true);
    }
    
    _this.cache.$cartIconIndicator.removeClass('hide');
  }

  // Error handling reference from Shopify.onError in api.jquery.js
  cart.prototype.error = function(XMLHttpRequest) {
    var _this = this;
    var data = JSON.parse(XMLHttpRequest.responseText);

    if (data.message) {
      if (_this.isUpsell) {
        _this.$form.append('<p class="error"><small>'+data.description+'</small></p>');
      } else {
        theme.Notify.open('error', data.description, true);
      }
    }
  };

  cart.prototype.addFreeItems = function(cartItems) {
    var _this = this;
    var variants = _this.freeProduct.split(",");

    var cartItems = cartItems, 
    cartUpdates = {},
    count = 0;

    $.each(variants, function(_, variant_id){
      const cart_variant = cartItems.find(v => v.id == variant_id);
      if (cart_variant) {
        cartUpdates[variant_id] = ++cart_variant.quantity;
      } else {
        cartUpdates[variant_id] = 1;
      }
      count++;
    }); 

    if (count == variants.length){
      var params = {
        type: 'POST',
        url: '/cart/update.js',
        data: { updates: cartUpdates },
        dataType: 'json',
        success: function(data) {
          _this.cache.$cartIconIndicator.text(data.item_count);
          _this.success2();
        }
      };
      $.ajax(params);
    }
  };

  return cart;
})();

window.Notify = (function() {
  var notify = function() {
    this.cache = {
      $scrollParent: $('html').add('body'),
      $notificationSuccess: $('#NotificationSuccess'),
      $notificationSuccessLink: $('#NotificationSuccess').find('a'),
      $notificationError: $('#NotificationError'),
      $notificationPromo: $('#NotificationPromo'),
      $notificationClose: $('.notification__close'),
      $notificationErrorMessage: $('.notification__message--error')
    };

    this.settings = {
      notifyActiveClass: 'notification--active',
      closeTimer: 5000,
      promoKeyName: 'promo-' + this.cache.$notificationPromo.data('text')
    };

    this.notifyTimer;
    this.$lastFocusedElement = null;

    this.isLocalStorageSupported = isLocalStorageSupported();


    this.cache.$notificationClose.on('click', this.close.bind(this));
    this.showPromo();
    this.adaptNotification();
  };

  function isLocalStorageSupported() {
    // Return false if we are in an iframe without access to sessionStorage
    if (window.self !== window.top) {
      return false;
    }

    var testKey = 'test';
    try {
      var storage = window.sessionStorage;
      storage.setItem(testKey, '1');
      storage.removeItem(testKey);
      return true;
    } catch (error) {
      return false;
    }
  }

  notify.prototype.open = function(state, message, autoclose) {
    this.close();

    if (state === 'success') {
      this.cache.$notificationSuccess
        .attr('aria-hidden', false)
        .addClass(this.settings.notifyActiveClass);

      // Set last focused element to return to once success
      // notification is dismissed (by timeout)
      this.$lastFocusedElement = $(document.activeElement);

      // Set focus on link to cart after transition
      this.cache.$notificationSuccess.one(
        'TransitionEnd webkitTransitionEnd transitionend oTransitionEnd',
        $.proxy(function() {
          slate.a11y.pageLinkFocus(this.cache.$notificationSuccessLink);
        }, this)
      );

      // Fallback for no transitions
      if (this.cache.$scrollParent.hasClass('no-csstransitions')) {
        slate.a11y.pageLinkFocus(this.cache.$notificationSuccessLink);
      }
    } else {
      this.cache.$notificationErrorMessage.html(message);
      this.cache.$notificationError
        .attr('aria-hidden', false)
        .addClass(this.settings.notifyActiveClass);
    }

    // Timeout to close the notification
    if (autoclose) {
      clearTimeout(this.notifyTimer);
      this.notifyTimer = setTimeout(
        this.close.bind(this),
        this.settings.closeTimer
      );
    }
  };

  notify.prototype.close = function(evt) {
    if (evt && $(evt.currentTarget).attr('id') === 'NotificationPromoClose') {
      if (this.isLocalStorageSupported) {
        localStorage.setItem(this.settings.promoKeyName, 'hidden');
      }
    }

    // Return focus to previous element if one is defined
    // and the user has not strayed from the success notification link
    if (
      this.$lastFocusedElement &&
      this.cache.$notificationSuccessLink.is(':focus')
    ) {
      slate.a11y.pageLinkFocus(this.$lastFocusedElement);
    }

    // Close all notification bars
    this.cache.$notificationSuccess
      .attr('aria-hidden', true)
      .removeClass(this.settings.notifyActiveClass);
    this.cache.$notificationError
      .attr('aria-hidden', true)
      .removeClass(this.settings.notifyActiveClass);
    this.cache.$notificationPromo
      .attr('aria-hidden', true)
      .removeClass(this.settings.notifyActiveClass);

    // Reset last focused element
    this.$lastFocusedElement = null;
  };

  notify.prototype.showPromo = function(SFEevent) {
   
    // If reloaded in the storefront editor, update selectors/settings
    if (SFEevent) {
      this.initCache();
    }
 
    if (
      this.isLocalStorageSupported &&
      localStorage[this.settings.promoKeyName] === 'hidden'
    ) {
      return;
    }

    this.cache.$notificationPromo
      .attr('aria-hidden', false)
      .addClass(this.settings.notifyActiveClass);
  };

  notify.prototype.adaptNotification = function() {
    var adaptHeight = $('.hero').data('adapt-height'),
      $notification = $('#NotificationPromo'),
      $notificationInner = $notification.children('.notification__inner');

    if (!$notification.length) {
      return;
    }

    $notification.toggleClass(
      'notification-adapt page-width',
      adaptHeight === true
    );
    $notificationInner.toggleClass('page-width', adaptHeight === false);
  };

  return notify;
})();

theme.stickyHeader = (function() {
  var selectors = {
    searchCartWrapper: '#SiteNavSearchCart',
    stickyNavWrapper: '#StickNavWrapper',
    stickyBar: '#StickyBar'
  };

  var config = {
    lastScroll: 0,
    navClass: 'sticky--active',
    openTransitionClass: 'sticky--open',
    closeTransitionClass: 'sticky--close'
  };

  var cache = {};

  function cacheSelectors() {
    cache = {
      $window: $(window),
      $siteNavSearchCart: $(selectors.searchCartWrapper),
      $stickyBar: $(selectors.stickyBar)
    };
  }

  function init() {
    cacheSelectors();
    config.isActive = false;
    cache.$window.on('scroll.stickynav', stickyHeaderOnScroll);
  }

  function stickyHeaderOnScroll() {
    var scroll = cache.$window.scrollTop();
    var $el = $(selectors.stickyNavWrapper);
    var threshold = $el.offset().top + $el.height() + 10; // default for scrolling down

    // Check if scrolling up
    if (scroll < config.lastScroll) {
      threshold = $el.offset().top;
    }

    if (scroll > threshold) {
      stickNav();
    } else {
      unstickNav();
    }

    config.lastScroll = scroll;
  }

  function stickNav() {
    if (config.isActive) {
      return;
    }

    config.isActive = true;

    cache.$stickyBar.addClass(config.navClass);

    // Add open transition class after element is set to fixed
    // so CSS animation is applied correctly
    setTimeout(function() {
      cache.$stickyBar.addClass(config.openTransitionClass);
    }, 0);
  }

  function unstickNav() {
    if (!config.isActive) {
      return;
    }

    cache.$stickyBar
      .removeClass(config.openTransitionClass)
      .removeClass(config.navClass);

    config.isActive = false;
  }

  function unload() {
    $(window).off('.stickynav');
  }

  return {
    init: init,
    unload: unload
  };
})();

theme.headerNav = (function() {
  var selectors = {
    siteNav: '#SiteNav',
    siteNavParent: '#SiteNavParent',
    siteNavItem: '.site-nav__item',
    stickyNavWrapper: '#StickNavWrapper',
    stickyNav: '#StickyBar',
    stickyNavInner: '#StickyNav',
    megaNavText: '.nav-bar .meganav__text-hover',
    mobileNav: '.mobile-nav',
    mobileNavToggle: '.mobile-nav-toggle',
    mobileNavItem: '.mobile__nav-toggle',
    siteNavDropdown: '.site-nav__dropdown'
  };

  var config = {
    lastScroll: 0,
    isActive: false,
    navClass: 'sticky--active',
    openTransitionClass: 'sticky--open',
    closeTransitionClass: 'sticky--close',
    searchInnerActiveClass: 'search-header__search-inner--active'
  };

  function init() {
    sizeNav();
    initMegaNavs();
    mobileNav();

    $(window).resize(sizeNav);
  }

  function sizeNav() {
    $(selectors.megaNavText).each(function() {
      // Add offset to text displayed in meganav
      var childOffset = $(this).closest('.site-nav__item').offset().left - 10;
      
      $(this).css('margin-left', childOffset);
      $(this).css('width', $(this).width() - childOffset);
    });

    $(selectors.stickyNavWrapper).height($(selectors.stickyNavInner).outerHeight());
    $(selectors.siteNav).removeClass('hide');  
  }

  function initMegaNavs() {
    new window.Meganav({
      $meganavs: $('.site-nav__dropdown'),
      $meganavToggle: $('.site-nav__link-toggle'),
      preventDuplicates: true,
      closeOnPageClick: true,
      closeThirdLevelOnBlur: true
    });

    new window.Meganav({
      $meganavs: $('.meganav--index'),
      $meganavToggle: $('.index__meganav-toggle')
    });

    new window.Meganav({
      $meganavs: $('.meganav--drawer'),
      $meganavToggle: $('.drawer__meganav-toggle')
    });
  }

  function unload() {
    $(window).off('.stickynav');
  }

  function mobileNav() {
    $(selectors.mobileNavToggle).on('click', function() {
      $(this).toggleClass('open');
      $(selectors.mobileNav).toggleClass('open');
    })

    $(selectors.mobileNavItem).on('click', function() {
      var nav = $(this).attr('aria-controls');
      $('#'+nav).toggleClass('open')
      $(this).toggleClass('open')
    })
  }

  return {
    init: init,
    unload: unload
  };
})();

theme.VideoURL =(function() {
  var defaults = {};

  function VideoURL(container) {
    this.$container = $(container);

    this.settings = $.extend({}, defaults, {
      videoURL: this.$container.attr('data-video'),
      controls: this.$container.attr('data-controls'),
      playButton: this.$container.find('.controller'),
      title: this.$container.attr('data-video-title'),
    });

    this.selectors = {
      videoModal: 'VideoModal'
    }

    this.init()
  }

  VideoURL.prototype = _.assignIn({}, VideoURL.prototype, {
      init: function() {
        this._createVideo()
      },
      _parseVideo: function() {
        var url = this.settings.videoURL;

        url.match(/(http:|https:|)\/\/(player.|www.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/);
        
        if (RegExp.$3.indexOf('youtu') > -1) {
            var type = 'youtube';
        } else if (RegExp.$3.indexOf('vimeo') > -1) {
            var type = 'vimeo';
        } else  {
          url.match('\\.([^/#?]+)([#?][^/]*)?$');
          var type = RegExp.$1;
        }

        return {
          type: type,
          id: RegExp.$6
        };
      },
      _createVideo: function() {
          var videoObj = this._parseVideo(this.settings.videoURL);
          var $element = '';

          if(videoObj.type == 'mp4') {
            $element = $('<video>');
            $element.html('<source src="'+this.settings.videoURL+'" type="video/mp4" />')
       
            $element.attr('controls', 'true');
            $element.attr('preload', 'auto');
            $element.attr('loop', 'true');
          } else {
            $element = $('<iframe>');
            $element.attr('frameborder', 0);
            $element.attr('title', this.settings.title);
            if (videoObj.type == 'youtube') {
                $element.attr('src', '//www.youtube.com/embed/' + videoObj.id + '?rel=0&enablejsapi=1');
            } else if (videoObj.type == 'vimeo') {
                $element.attr('src', '//player.vimeo.com/video/' + videoObj.id);
            }
          }
          
          $element.attr('class', 'video');

          if (this.settings.controls) {
            var $videoWrapper = $('#'+this.selectors.videoModal).find('.video-wrapper');

             var VideoModal = new window.Modals(
              this.selectors.videoModal,
              'video-modal'
            );

            $videoWrapper.html($element);

            if (videoObj.type == 'youtube' || videoObj.type == 'vimeo') {
              $videoWrapper.addClass('iframe');
            }

            $(this.settings.playButton).on('click', function() {
              VideoModal.open();
            })
          } else {
            this.$container.html($element);
          }
          
      }
  });

  return VideoURL;
})();

theme.Quantity = (function() {
  var selectors = {
    container: '.cart__cell--quantity'
  };

  function init() {
    var $containers = $(selectors.container);

    $containers.each(function() {
      var $increase = $(this).find('.controls.plus');
      var $decrease = $(this).find('.controls.minus');
      
      var item = $(this).attr('data-item');
      var $input = $(this).find('#Updates_'+item);
  
      $increase.on('click', function() {
        var value = parseInt($input.val()) + 1;
        $input.val(value);
      })
  
      $decrease.on('click', function() {
        var value = parseInt($input.val()) - 1;
        $input.val(value);
      })
    })
    
  }

  return {
    init: init
  };
})();

/*================ TEMPLATES ================*/
theme.customerTemplates = (function() {
  function customerTemplates() {
    this.init();
  }

  customerTemplates.prototype = _.assignIn({}, customerTemplates.prototype, {
    init: function() {
      this.customerAddressForm();

      this.checkUrlHash();

         // Show reset password form
        $('#RecoverPassword').on('click', function(evt) {
          evt.preventDefault();
          this.toggleRecoverPasswordForm();
        }.bind(this));

        // Hide reset password form
        $('#HideRecoverPasswordLink').on('click', function(evt) {
          evt.preventDefault();
          this.toggleRecoverPasswordForm();
        }.bind(this));
    },
    toggleRecoverPasswordForm: function() {
      /**
       *
       *  Show/Hide recover password form
       *
      */
       $('#RecoverPasswordForm').toggleClass('hide');
       $('#CustomerLoginForm').toggleClass('hide');
    },
    resetPasswordSuccess: function() {
        /**
         *
         *  Show reset password success message
         *
         */
        // check if reset password form was successfully submited
        if (!$('.reset-password-success').length) {
          return;
        }

        // show success message
        $('#ResetSuccess').removeClass('hide');
    },
    customerAddressForm: function() {
        /**
             *
             *  Show/hide customer address forms
             *
             */
        var $newAddressForm = $('#AddressNewForm');

        if (!$newAddressForm.length) {
          return;
        }

        // Initialize observers on address selectors, defined in shopify_common.js
        if (Shopify) {
          // eslint-disable-next-line no-new
          new Shopify.CountryProvinceSelector(
            'AddressCountryNew',
            'AddressProvinceNew',
            {
              hideElement: 'AddressProvinceContainerNew'
            }
          );
        }

        // Initialize each edit form's country/province selector
        $('.address-country-option').each(function() {
          var formId = $(this).data('form-id');
          var countrySelector = 'AddressCountry_' + formId;
          var provinceSelector = 'AddressProvince_' + formId;
          var containerSelector = 'AddressProvinceContainer_' + formId;

          // eslint-disable-next-line no-new
          new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
            hideElement: containerSelector
          });
        });

        // Toggle new/edit address forms
        $('.address-new-toggle').on('click', function() {
          $newAddressForm.toggleClass('hide');
        });

        $('.address-edit-toggle').on('click', function() {
          var formId = $(this).data('form-id');
          $('#EditAddress_' + formId).toggleClass('hide');
        });

        $('.address-delete').on('click', function() {
          var $el = $(this);
          var addressUrl = $el.data('address-url');
          var confirmMessage = $el.data('confirm-message');

          // eslint-disable-next-line no-alert
          if (
            confirm(
              confirmMessage || 'Are you sure you wish to delete this address?'
            )
          ) {
            Shopify.postLink(addressUrl, {
              parameters: { _method: 'delete' }
            });
          }
        });
    },
    checkUrlHash: function() {
        /**
             *
             *  Check URL for reset password hash
             *
             */
        var hash = window.location.hash;

        // Allow deep linking to recover password form
        if (hash === '#recover') {
          this.toggleRecoverPasswordForm();
        }
    }
  });

  return customerTemplates;
})();

/*================ SECTIONS ================*/
theme.HeaderSection = (function() {
  function Header() {
    theme.stickyHeader.init();
    theme.headerNav.init();
    theme.Notify = new window.Notify();
  }

  Header.prototype = _.assignIn({}, Header.prototype, {
    onSelect: function() {
      theme.Notify.adaptNotification();
    },
    onUnload: function() {
      theme.stickyHeader.unload();
      theme.headerNav.unload();
    }
  });

  return Header;
})();

theme.Product = (function() {
   
  
  var defaults = {
    smallBreakpoint: 750, // copied from variables.scss
    productThumbIndex: 0,
    productThumbMax: 0
  };

  function Product(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');

    this.selectors = {
      originalSelectorId: '#ProductSelect-' + sectionId,
      productZoomImage: '#ProductZoomImg',
      addToCart: '#AddToCart-' + sectionId,
      productPrice: '#ProductPrice-' + sectionId,
      productPriceLabel: '#ProductPriceLabel-' + sectionId,
      comparePrice: '#ComparePrice-' + sectionId,
      productField: '#ProductID-' + sectionId,
      addToCartText: '#AddToCartText-' + sectionId,
      SKU: '.variant-sku',
      productImageContainers: '.product__photo-container-' + sectionId,
      productImageWrappers: '.product__photo-wrapper-' + sectionId,
      productImageSlider: '.photos__photo-slider-' + sectionId,
      productStock: '#ProductStock-' + sectionId,
      singleOptionSelector: '.single-option-selector-' + sectionId,
      unitPrice: '[data-unit-price]',
      unitPriceBaseUnit: '[data-unit-price-base-unit]',
      unitPriceContainer: '[data-unit-price-container]',
      notifyMeButton: '#NotifyMe-' + sectionId,
      notifyModal: 'NotifyModal'
    };

    this.settings = $.extend({}, defaults, {
      sectionId: sectionId,
      available: $container.data('available'),
      enableHistoryState: $container.data('enable-history-state') || false,
      namespace: '.product-' + sectionId,
      productName: $container.data('product')
    });

    // Stop parsing if we don't have the product json script tag
    if (!$('#ProductJson-' + sectionId).html()) {
      return;
    }

    this.productSingleObject = JSON.parse(
      $('#ProductJson-' + sectionId).html()
    );

    this.init();
  }

  Product.prototype = _.assignIn({}, Product.prototype, {
    init: function() {
      this._notifyMe();


      if (this.settings.sectionId == 'product-template') {
        this._initVariants();
        this._productZoomImage();
        this._productThumbnailSlider();
        this._stickyAddToCart();
      }

      theme.AjaxCart = new window.AjaxCart(
        $('#AddToCartForm-' + this.settings.sectionId)
      );

    },
    _notifyMe: function() {
      if (!this.settings.available) {
        var NotifyModal = new window.Modals(
          this.selectors.notifyModal,
          'notify-modal'
        );

        $(this.selectors.notifyMeButton).on('click', function(evt) {
          evt.preventDefault();
          $('#'+this.selectors.notifyModal).find('input[name="contact[product-enquiry]"]').val(this.settings.productName)
          NotifyModal.open();
        }.bind(this))
      }
    },

    _initVariants: function() {
      var options = {
        $container: this.$container,
        enableHistoryState: this.settings.enableHistoryState,
        product: this.productSingleObject,
        singleOptionSelector: this.selectors.singleOptionSelector,
        originalSelectorId: this.selectors.originalSelectorId
      };

      // eslint-disable-next-line no-new
      this.variants = new slate.Variants(options);

      this.$container.on(
        'variantChange' + this.settings.namespace,
        this._updateVariantChange.bind(this)
      );
      this.$container.on(
        'variantPriceChange' + this.settings.namespace,
        this._updatePrice.bind(this)
      );
      this.$container.on(
        'variantSKUChange' + this.settings.namespace,
        this._updateSKU.bind(this)
      );
      this.$container.on(
        'variantImageChange' + this.settings.namespace,
        this._updateImages.bind(this)
      );
    },

    _updateVariantChange: function(evt) {
    
      var variant = evt.variant;

      var cache = {
        $addToCart: $(this.selectors.addToCart),
        $addToCartText: $(this.selectors.addToCartText),
        $productPriceLabel: $(this.selectors.productPriceLabel)
      };

      if (variant) {
        // Replace the 'Starting from' price label text
        cache.$productPriceLabel.text('Our low price');
        
        // Select a valid variant if available
        if (variant.available) {
          // We have a valid product variant, so enable the submit button
          cache.$addToCart.removeClass('btn--sold-out').prop('disabled', false);
          cache.$addToCartText.html(theme.strings.addToCart);
          $(this.$container).show();
        } else {
          // Variant is sold out, disable the submit button
          cache.$addToCart.prop('disabled', true).addClass('btn--sold-out');
          cache.$addToCartText.html(theme.strings.soldOut);
          // $(this.$container).hide();
        }

        // Dynamically changing the Stock alert when switching variants
        var productStockInnerDiv = $('.product-stock-inner');
        var productStockInnerText = $('.product-stock-status');
        var productStockInnerInfo = $('.stock-info');
        var variantInput = $('input[data-variantid='+variant.id+']');
        var variantIncoming = variantInput.attr('data-incoming');
        var variantIncomingDate = variantInput.attr('data-next-incoming-date');

        if (variantIncoming === true || variantIncomingDate.length > 0) {
          productStockInnerDiv.addClass('preorder-stock');
          productStockInnerDiv.removeClass('in-stock');
          productStockInnerText.text(" pre-order ");
          if (variantIncomingDate) {
            productStockInnerInfo.html("Pre-order stock that will arrive on "+variantIncomingDate);
          } else {
            productStockInnerInfo.html("More stock arriving shortly, pre-order now");
          }
        } else {
          productStockInnerDiv.removeClass('preorder-stock');
          productStockInnerDiv.addClass('in-stock');
          productStockInnerText.text(" in-stock ");
          productStockInnerInfo.empty();
        }

        $(this.selectors.unitPriceContainer, this.$container).addClass('hide');

        if (variant.unit_price_measurement) {
          var $unitPrice = $(this.selectors.unitPrice, this.$container);
          var $unitPriceBaseUnit = $(
            this.selectors.unitPriceBaseUnit,
            this.$container
          );

          $unitPrice.html(
            theme.Currency.formatMoney(variant.unit_price, theme.moneyFormat)
          );
          $unitPriceBaseUnit.html(this._getBaseUnit(variant));

          $(this.selectors.unitPriceContainer, this.$container).removeClass(
            'hide'
          );
        }
      } else {
        cache.$addToCart.prop('disabled', true).removeClass('btn--sold-out');
        cache.$addToCartText.html(theme.strings.unavailable);
        // $(this.$container).hide();
      }
    },

    _updatePrice: function(evt) {
      var variant = evt.variant;
      if (variant) {
        $(this.selectors.productPrice).html(
          theme.Currency.formatMoney(variant.price, theme.moneyFormat)
        );

        $(this.selectors.productField).val(variant.id);

        // Update and show the product's compare price if necessary
        if (variant.compare_at_price > variant.price) {
          $(this.selectors.comparePrice)
            .html(
              theme.Currency.formatMoney(
                variant.compare_at_price,
                theme.moneyFormat
              )
            )
            .removeClass('hide');
        } else {
          $(this.selectors.comparePrice).addClass('hide');
        }
      } else {
        $(this.selectors.comparePrice).addClass('hide');
      }
    },

    _getBaseUnit: function(variant) {
      return variant.unit_price_measurement.reference_value === 1
        ? variant.unit_price_measurement.reference_unit
        : variant.unit_price_measurement.reference_value +
            variant.unit_price_measurement.reference_unit;
    },

    _updateSKU: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(this.selectors.SKU).html(variant.sku);
      }
    },

    _updateImages: function(evt) {
      var variant = evt.variant;

      if (variant && variant.featured_image) {
        var imageId = variant.featured_image.id;
        this.switchProductImage(imageId);
      }
    },

    switchProductImage: function(imageId) {
      var $imageToShow = $(
        this.selectors.productImageContainers +
          "[data-image-id='" +
          imageId +
          "']",
        this.$container
      );
      var $imagesToHide = $(
        this.selectors.productImageContainers +
          ":not([data-image-id='" +
          imageId +
          "'])",
        this.$container
      );
      $imagesToHide.addClass('hide');
      $imageToShow.removeClass('hide');
    },

    _productZoomImage: function() {
      // The zoom image is only used on the product template, so return early
      // even if a featured product section is present.
      if (
        !$('.product-single ' + this.selectors.productImageContainers).length
      ) {
        return;
      }

      var self = this;

      $(this.selectors.productImageWrappers).on(
        'click' + this.settings.namespace,
        function(evt) {
          evt.preventDefault();
          // Empty src before loadig new image to avoid awkward image swap
          $(self.selectors.productZoomImage)
            .attr('src', '')
            .attr('src', $(this).attr('href'));
        }
      );
    },

    _stickyAddToCart: function() {
      var $cartButton = $('.product-form__item--submit').find('.btn');
      var $stickyBar = $('.sticky-button');

      if ($stickyBar.length && $cartButton.length) {
        var cartButtonText = $cartButton.text();
        var $newButton = $('<button class="btn--light btn--full">'+cartButtonText+'</button>');
        var offset = $cartButton.offset().top;

        if ($stickyBar.find('.btn--light').length == 0) {
          $stickyBar.find('.sticky-content').append($newButton);
        }

        $newButton.on('click', function() {
          $cartButton.click();
        })

        $(window).on('scroll', function (event) {
          var scroll = $(window).scrollTop();
          
          if (scroll > offset) {
              $stickyBar.css('max-height', '200px')
          } else {
              $stickyBar.css('max-height', '0')
          }
      });
      }
    },

    /*
      Thumbnail slider
     */
    _productThumbnailSlider: function() {
      var $productImageSlider = $(this.selectors.productImageSlider);
      $productImageSlider.slick({
        arrows: true,
        initialSlide: 1,
        dots: true,
        adaptiveHeight: true,
        prevArrow: $productImageSlider.parent().find('.prev'),
        nextArrow: $productImageSlider.parent().find('.next'),
      });
    }
  });
    
  

  return Product;
})();

theme.slideshows = {};

theme.Slideshow = (function() {
  function Slideshow(container) {
    this.$container = $(container);
    var sectionId = this.$container.attr('data-section-id');
    this.slideshow = '#Slideshow-' + sectionId;

    theme.slideshows[this.slideshow] = new theme.Hero(this.slideshow);
  }

  Slideshow.prototype = _.assignIn({}, Slideshow.prototype, {
    onUnload: function() {
      theme.slideshows[this.slideshow].destroy();
    },

    onSelect: function() {
      theme.Notify.adaptNotification();
    },

    onDeselect: function() {
    },

    onBlockSelect: function(evt) {
      var $slide = $(
        '.hero__slide--' + evt.detail.blockId + ':not(.slick-cloned)'
      );
      var slideIndex = $slide.data('slick-index');

      theme.slideshows[this.slideshow].goToSlide(slideIndex);
    },

    onBlockDeselect: function() {
    }
  });

  return Slideshow;
})();

theme.Cart = (function() {
  var selectors = {
    checkoutForm:   'form.cart',
    remove:   '.cart__remove-item.ajax',
    productSwap: '.js-modal-update',
    modalCloseText: '.js-modal-close-size',
    modalCloseButton: '.js-modal-close',
    qtyInput:   '.quantity-input input',
    qtyControls:   '.quantity-input .controls',
    qtyControlsPlus:   '.quantity-input .controls.plus',
    qtyControlsMinus:   '.quantity-input .controls.minus'
  };

  function Cart(container) {
    theme.cartObject = JSON.parse($('#CartJson').html());
// 	 theme.Quantity.init();
    this.init(this.$container);
  }

  Cart.prototype = _.assignIn({}, Cart.prototype, {
    init: function() {
      $(selectors.remove).on('click', function(el) {
        this._updateFreeItems($(el.target).attr('data-item'), 0);
      }.bind(this));
      

      $(selectors.qtyControls).on('click', function(el) {
        var $input = $(el.target).parent().find('input')
        
        if ($(el.target).hasClass('plus')) {
        	var value = parseInt($input.val()) + 1;
	        $input.val(value);
        }
        
         if ($(el.target).hasClass('minus')) {
        	var value = parseInt($input.val()) - 1;
	        $input.val(value);
        }
        
        var productType = $(el.target).parent().attr('data-type');
        var productID = $(el.target).parent().attr('data-item');
        var newValue = $input.val();

        if(productType == 'Trampoline') {
          this._updateFreeItems(productID, newValue)
        } else {
          this._updateItems({
            [productID]: newValue
          })
        }
      }.bind(this));

      $(selectors.productSwap).on('click', function(el) {
        if ($(el.target).attr('data-current-accessory-ids')) {
          this._swapItems($(el.target).attr('data-current-accessory-ids').split(','), $(el.target).attr('data-new-accessory-ids').split(','));
        }
      }.bind(this));

      $(selectors.modalCloseText).on('click', function() {
        $('#cart-modal').removeClass('modal--is-active');
      }.bind(this));

      $(selectors.modalCloseButton).on('click', function() {
        $('#cart-modal').removeClass('modal--is-active');
      }.bind(this));
    

      function showModal() {
        if (!window.sessionStorage.getItem('cart-modal-shown')) {
            $('#cart-modal').addClass('modal--is-active');
            window.sessionStorage.setItem('cart-modal-shown', true);
        }
      }
      function waitForDiscount(selector) {
        return new Promise(resolve => {
          if (document.querySelector(selector)) {
              return resolve(document.querySelector(selector));
          }
  
          const observer = new MutationObserver(mutations => {
              if (document.querySelector(selector)) {
                  resolve(document.querySelector(selector));
                  observer.disconnect();
              }
          });
  
          observer.observe(document.body, {
              childList: true,
              subtree: true
          });
        });
      }
      $(function(){
        setTimeout(showModal, 10000); // wait 10 seconds
        waitForDiscount('.geolizr-currency').then((el) => { // wait until discount code is applied

          // calculate new total and total savings

          var discount = $('.geolizr-currency').data('geolizr-price');
          var total = $('.cart-total');
          var totalSavings = $('.cart-total-savings');

          var totalAmount = parseInt(total.text().replace(/[^0-9 ]/g, '')) * 100;
          var totalSavingsAmount = parseInt(totalSavings.text().replace(/[^0-9 ]/g, '')) * 100;

          var newTotal = totalAmount - discount;
          var newTotalSavings = totalSavingsAmount + discount;

          total.text(theme.Currency.formatMoney(newTotal, theme.moneyFormat))
          totalSavings.text(theme.Currency.formatMoney(newTotalSavings, theme.moneyFormat));
        });
        // make box max width
        waitForDiscount('.docapp-coupon-input').then((el) => {
          $('.docapp-coupon-input').css('max-width','none');
        });
      });
      
    },
    // Update free items if trampoline quantity changes
    _updateFreeItems: function(productID, newValue) {
      var freeProducts = $(selectors.checkoutForm).find('input[name="free-products"]').val()
      var existing = false;
      var cartUpdates = {
        [productID]: newValue
      }

      $.each(theme.cartObject.items, function(index, item) {
        if(item.product_type == 'Trampoline' && item.id != productID) {
          existing = true
          return
        }
      })

      if (freeProducts && !existing) {
        freeProducts = freeProducts.split(",");
        $.each(freeProducts, function(index, variant_id) {
          cartUpdates[variant_id] = newValue;
        })
      }

      this._updateItems(cartUpdates)
    },
    // swap out variants of wrong size
    _swapItems: function(currentIds, newIds) {
      var cartUpdates = {}

      for (var i = 0; i < currentIds.length; i++) {
        if (newIds[i] != '_') {
          cartUpdates[currentIds[i]] = 0;
          cartUpdates[newIds[i]] = 1;
        }
      }

      this._updateItems(cartUpdates)
    },
    _updateItems: function(cartUpdates) {
      var params = {
        type: 'POST',
        url: '/cart/update.js',
        data: { updates: cartUpdates },
        dataType: 'json',
        success: function() {
          location.reload();
        }
      };
      $.ajax(params);
    }
  });

  return Cart;
})();

theme.InstagramFeed = (function() {
  function InstagramFeed(container) {
    this.$container = $(container);

    this.$container.slick({
      infinite: true,
      arrows: true,
      slidesToShow: 5,
      slidesToScroll: 1,
      prevArrow: this.$container.parent().find('.prev'),
      nextArrow: this.$container.parent().find('.next'),
      responsive: [
        {
          breakpoint: 1000,
          settings: {
              infinite: true,
              slidesToShow: 3
          }
        },
        {
          breakpoint: 800,
          settings: {
              infinite: true,
              slidesToShow: 2
          }
      },
      {
          breakpoint: 600,
          settings: {
              infinite: true,
              slidesToShow: 1
          }
      }]
    })
  }

  return InstagramFeed;
})();

theme.ColumnsSlider = (function() {

  function ColumnsSlider(container) {
    $(container).slick({
      dots: true,
      infinite: false,
      arrows: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      prevArrow: $(container).parent().find('.prev'),
      nextArrow: $(container).parent().find('.next'),
      responsive: [
        {
          breakpoint: 1000,
          settings: {
              slidesToShow: 2
          }
        },
        {
          breakpoint: 600,
          settings: {
              infinite: true,
              slidesToShow: 1
          }
        }
      ]
    })


    $(container).find('.slick-slide').each(function () {    
      var $slide = $(this);
      if ($slide.attr('aria-describedby') != undefined) { 
        $(this).attr('id', $slide.attr('aria-describedby'));      
      }
    });
  }


  return ColumnsSlider;
})();

theme.ColumnsSliderTree = (function() {

  function ColumnsSliderTree(container) {
    $(container).slick({
      dots: true,
      infinite: false,
      arrows: true,
      slidesToShow: 6,
      slidesToScroll: 1,
      prevArrow: $(container).parent().find('.prev'),
      nextArrow: $(container).parent().find('.next'),
      responsive: [
        {
          breakpoint: 1000,
          settings: {
              slidesToShow: 2
          }
        },
        {
          breakpoint: 600,
          settings: {
              infinite: true,
              slidesToShow: 1
          }
        }
      ]
    })


    $(container).find('.slick-slide').each(function () {    
      var $slide = $(this);
      if ($slide.attr('aria-describedby') != undefined) { 
        $(this).attr('id', $slide.attr('aria-describedby'));      
      }
    });
  }


  return ColumnsSliderTree;
})();

theme.TrampolineSpecs = (function() {
  var selectors = {
    table: '.specs-table',
    productRow: '.specs-table th, .specs-table td'
  }

  function TrampolineSpecs(container) {
    this.$container = $(container);

    this.settings = {
      product: this.$container.attr('data-product')
    }

    this.init(this.$container);
  }

  TrampolineSpecs.prototype = _.assignIn({}, TrampolineSpecs.prototype, {
    init: function() {
      this._activeColumn();
      this._selectColumn();
    },
    _activeColumn: function() {
      $('[data-column]').removeClass('active')
      $('[data-table]').removeClass('active')
      $('[data-column="'+this.settings.product+'"]').addClass('active')
      $('[data-title]').text(this.settings.product.replace('-trampoline', ' '))
      $('[data-table="'+this.settings.product+'"]').addClass('active')
    },
    _selectColumn: function() {
      var _this = this;
      $('[data-column]').on('click', function() {
        _this.settings.product = $(this).attr('data-column')
        _this._activeColumn();
      })
    }
  });

  return TrampolineSpecs;
})();

theme.init = function() {
  slate.rte.wrapTable();
  slate.rte.iframeReset();

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('a[href^="#"]').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

   /* Contact form posted
  --------------------------------------*/

  function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return typeof sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
  };

  if (getUrlParameter('contact_posted')){
    $('#NotificationForm').addClass('notification--active');
    $(document).on('click', '#NotificationForm .notification__close-form-success', function() { 
      $('#NotificationForm').removeClass('notification--active');
    });
  }

  /* Browser detection
  --------------------------------------*/

  function browserDetect() {
    var ua = navigator.userAgent,
        tem,
        M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];

    if (/trident/i.test(M[1])) {
        tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
        return 'ie-' + (tem[1] || '');
    }

    if (M[1] === 'Chrome') {
        tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
        if (tem != null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
    }

    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];

    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);

    return M.join(' ');
  }

  function browserClass() {
      var className = browserDetect().replace(' ', '-');
      return className.toLowerCase();
  }

  $('html').addClass(browserClass());

  // Replace html entity icon that appears
//   $("body").children().each(function() {
//     $(this).html($(this).html().replace(/&#8232;/g," "));
//   });

  $(".template-product .section-wrapper__row-block .description-column strong").each(function() {
    $(this).replaceWith( "<h2 style='margin-top: 30px;'>" + $(this).text() + "</h2>" )
  });

  // Sections
  var sections = new theme.Sections();
  sections.register('header', theme.HeaderSection);
  sections.register('product', theme.Product);
  sections.register('add-to-cart', theme.Product);
  sections.register('slideshow', theme.Slideshow);
  sections.register('cart', theme.Cart);
  sections.register('instagram-feed', theme.InstagramFeed);
  sections.register('columns', theme.ColumnsSlider);
  sections.register('columnstree', theme.ColumnsSliderTree);  
  sections.register('video-url', theme.VideoURL);
  sections.register('trampoline-specs', theme.TrampolineSpecs);
  sections.register('customer-templates', theme.customerTemplates);
  
  
    
};
$(theme.init);